import CardBox from "@/src/mui-custom/card/card-box/card-box";
import CardTitleBox from "@/src/mui-custom/card/card-title-box/card-title-box";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import CardTitleText from "@/src/mui-custom/card/card-title-text/card-title-text";
import CardTitleDivider from "@/src/mui-custom/card/card-title-divider/card-title-divider";
import CardTitleContainer from "@/src/mui-custom/card/card-title-container/card-title-container";
import CardBodyBox from "@/src/mui-custom/card/card-body-box/card-body-box";
import ReactHtmlParser from "react-html-parser";
import DescriptionOverview
    from "@/src/components/journal-site/home/journal-overview/mui-custom/description-overview/description-overview";
import DetailsOverview
    from "@/src/components/journal-site/home/journal-overview/mui-custom/details-overview/details-overview";
import {Typography} from "@mui/material";
import JournalInfoCard from "@/src/mui-custom/journal-info-card/journal-info-card";
import InfoItem from "@/src/mui-custom/journal-info-card/info-item/info-item";
import {faBookOpen, faFileImage,} from '@fortawesome/pro-duotone-svg-icons';
import InfoItemTitle from "@/src/mui-custom/journal-info-card/info-item/info-item-title/info-item-title";
import InfoItemDescription
    from "@/src/mui-custom/journal-info-card/info-item/info-item-description/info-item-description";
import NextLink from "next/link";
import Link from "@mui/material/Link";
import JournalOverviewBox
    from "@/src/components/journal-site/home/journal-overview/mui-custom/journal-overview-box/journal-overview-box";
import JournalCoverImage from "@/src/components/journal-site/common/journal-cover-image/journal-cover-image";
import Journal from "@/src/_types/journal";

const JournalOverview = ({journal}: { journal: Journal }) => {

    const data = {
        journalOverviewDescription: journal.meta_data?.overview_description ?? '',
        journalDefaultCoverImage: journal.meta_data?.default_cover_image
            ? `${process.env.NEXT_PUBLIC_SERVICE_URI_CDN_SERVE}${journal.meta_data.default_cover_image}`
            : null,
        journalName: journal.title,
        organization: journal.organization,
        organization_link: journal.organization_link,
        e_issn: journal.meta_data?.issn_epub,
        e_issn_link: journal.meta_data?.issn_epub_link,
        p_issn: journal.meta_data?.issn_ppub,
        p_issn_link: journal.meta_data?.issn_ppub_link,
        journal_frequency: journal.meta_data?.frequency,
        journalOverview: journal.meta_data?.overview ?? '',
    }

    const {
        journalOverviewDescription,
        journalDefaultCoverImage,
        journalName,
        organization,
        organization_link,
        e_issn,
        e_issn_link,
        p_issn,
        p_issn_link,
        journal_frequency,
        journalOverview,
    } = data;

    return (
        <CardBox
            sx={{
                display: 'flex',
                paddingX: {xs: '.5rem', sm: '.75rem', md: '.75rem', lg: '1.5rem', xl: '1.5rem'},
                paddingTop: '1.5rem',
                paddingBottom: '3rem',
                alignItems: 'flex-start',
                justifyContent: 'center',
                flexWrap: 'wrap',
                width: '100%',
                flexDirection: {sm: 'column', md: 'column', lg: 'row', xl: 'row'},
            }}
        >
            <CardTitleContainer>
                <CardTitleBox>
                    <FontAwesomeIcon icon={faBookOpen} className={'icon'}/>
                    <CardTitleText variant={"h2"}>
                        {journal.options?.template_configs?.journal_overview?.journal_overview?.label}
                    </CardTitleText>
                </CardTitleBox>
                <CardTitleDivider/>
            </CardTitleContainer>
            <CardBodyBox>
                <DescriptionOverview>
                    {
                        ReactHtmlParser(
                            journalOverviewDescription
                        )
                    }
                </DescriptionOverview>
                <DetailsOverview>

                    <JournalCoverImage
                        journalName={journalName}
                        image={journalDefaultCoverImage}
                        icon={faFileImage}
                        width={194}
                        height={275}
                    />

                    <JournalInfoCard sx={{
                        width: {sm: '100%', md: '100%', lg: '60%', xl: '60%'},
                    }}>
                        {organization && (
                            <>
                                <InfoItem>
                                    <InfoItemTitle component={'span'}>
                                        <i className={`icon ${journal.options?.template_configs?.journal_overview?.organization?.icon}`}></i>
                                        {journal.options?.template_configs?.journal_overview?.organization?.label}
                                    </InfoItemTitle>
                                    <InfoItemDescription component={'span'}>
                                        {organization_link ? (
                                            <Link
                                                component={NextLink} href={organization_link} underline="none">
                                                {organization}
                                            </Link>
                                        ) : (
                                            <>
                                                {organization}
                                            </>
                                        )}
                                    </InfoItemDescription>
                                </InfoItem>
                            </>
                        )}

                        {((e_issn && e_issn !== '0000-0000') || (p_issn && p_issn !== '0000-0000')) && (
                            <InfoItem>
                                <InfoItemTitle component={'span'}>
                                    <i className={`icon ${journal.options?.template_configs?.journal_overview?.issn?.icon}`}></i>
                                    {journal.options?.template_configs?.journal_overview?.issn?.label}
                                </InfoItemTitle>
                                <InfoItemDescription component={'span'}>
                                    {e_issn && e_issn !== '0000-0000' && (
                                        <>
                                            {e_issn_link ? (
                                                <Link
                                                    component={NextLink} href={e_issn_link} underline="none">
                                                    {`p: ${e_issn}`}
                                                </Link>
                                            ) : (
                                                `e: ${e_issn}`
                                            )}
                                        </>
                                    )}

                                    {p_issn && p_issn !== '0000-0000' && (
                                        <>
                                            <Typography component="span" sx={{
                                                marginX: '.5rem',
                                                textShadow: '1px 1px 0 rgba(255,255,255,0.75)',
                                            }}>
                                                {'|'}
                                            </Typography>
                                            {p_issn_link ? (
                                                <Link
                                                    component={NextLink} href={p_issn_link} underline="none">
                                                    {`p: ${p_issn}`}
                                                </Link>
                                            ) : (
                                                `p: ${p_issn}`
                                            )}
                                        </>
                                    )}

                                </InfoItemDescription>
                            </InfoItem>
                        )}

                        {journal_frequency && (
                            <InfoItem>
                                <InfoItemTitle component={'span'}>
                                    <i className={`icon ${journal.options?.template_configs?.journal_overview?.frequency?.icon}`}></i>
                                    {journal.options?.template_configs?.journal_overview?.frequency?.label}
                                </InfoItemTitle>
                                <InfoItemDescription component={'span'} sx={{
                                    textTransform: 'capitalize'
                                }}>
                                    {journal_frequency}
                                </InfoItemDescription>
                            </InfoItem>
                        )}

                        {journalOverview && (
                            <JournalOverviewBox>
                                {
                                    ReactHtmlParser(
                                        journalOverview
                                    )
                                }
                            </JournalOverviewBox>
                        )}
                    </JournalInfoCard>
                </DetailsOverview>
            </CardBodyBox>
        </CardBox>
    )
}
export default JournalOverview
